import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CalendarToolbar({ view, setView, anchor, setAnchor, navigate, days }) {
  const { t, i18n } = useTranslation();
  const LOC = i18n.language || "en";

  const rangeLabel = useMemo(() => {
    if (view === "day") return anchor.toLocaleDateString(LOC, { weekday: "long", month: "long", day: "numeric", year: "numeric" });
    if (view === "month") return anchor.toLocaleDateString(LOC, { month: "long", year: "numeric" });
    const s = days[0], e = days[6];
    const sameMonth = s.getMonth() === e.getMonth();
    return `${s.toLocaleDateString(LOC, { month: "short", day: "numeric" })} – ${e.toLocaleDateString(LOC, sameMonth ? { day: "numeric", year: "numeric" } : { month: "short", day: "numeric", year: "numeric" })}`;
  }, [view, anchor, days, LOC]);

  const ViewBtn = ({ v }) => (
    <button data-testid={`view-${v}`} onClick={() => setView(v)}
      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${view === v ? "bg-white text-indigo-700 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}>
      {t(`cal.${v}`)}
    </button>
  );

  return (
    <div className="flex items-center justify-between gap-3 p-3.5 border-b border-slate-200 bg-white flex-wrap">
      <div className="flex items-center gap-2">
        <Button data-testid="cal-today" variant="outline" size="sm" onClick={() => setAnchor(new Date())} className="rounded-md h-8">{t("cal.today")}</Button>
        <div className="flex items-center">
          <button data-testid="cal-prev" onClick={() => navigate(-1)} aria-label="Previous" className="grid place-items-center w-8 h-8 rounded-md text-slate-500 hover:bg-slate-100 transition-colors"><ChevronLeft size={18} /></button>
          <button data-testid="cal-next" onClick={() => navigate(1)} aria-label="Next" className="grid place-items-center w-8 h-8 rounded-md text-slate-500 hover:bg-slate-100 transition-colors"><ChevronRight size={18} /></button>
        </div>
        <h3 className="text-[0.95rem] font-semibold tracking-tight text-slate-900 ml-1 flex items-center gap-2"><CalendarDays size={16} className="text-indigo-500" /> {rangeLabel}</h3>
      </div>
      <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1">
        <ViewBtn v="day" /><ViewBtn v="week" /><ViewBtn v="month" />
      </div>
    </div>
  );
}
